import { Button, FormControlLabel, IconButton, Switch, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router-dom';

import PlayIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import SkipNextSharpIcon from '@mui/icons-material/SkipNextSharp';
import SkipPreviousSharpIcon from '@mui/icons-material/SkipPreviousSharp';

import GameService from '../../../services/game.service';
import { toSecond } from '../../../common/utilities';
import { TEAM_ICON_DEFAULT } from '../../../common/staticData';

import '../../player/Profile.css';
import ClipEditButton from '../components/ClipEditButton';

const MultipleStatsVideoPlayer = ({ t }) => {
    const params = useParams();
    const [tagList, setTagList] = useState([]);
    const handle = useFullScreenHandle();
    const player = useRef(null);
    const [playRate, setPlayRate] = useState(1);
    const [play, setPlay] = useState(true);
    const [currentTime, setCurrentTime] = useState(0);
    const [videoURL, setVideoURL] = useState('');
    const [videoList, setVideoList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showLogo, setShowLogo] = useState(false);

    const fastVideo = (param) => {
        player.current && player.current.seekTo(currentTime + param);
    };

    const onProgress = (seconds) => {
        if (tagList.length === 0) return;

        setCurrentTime(seconds);

        const start = toSecond(tagList[currentIndex].start_time);
        const end = toSecond(tagList[currentIndex].end_time);

        if (seconds >= end) {
            if (currentIndex < tagList.length - 1) PlayVideo(1);
            else setPlay(false);
        } else if (seconds <= start) {
            if (playRate !== 1) {
                setPlay(false);
                setPlayRate(1);
            }

            player.current.seekTo(start);
            setPlay(true);
        }
    };

    const PlayVideo = (add) => {
        const index = currentIndex + add;

        if (index >= tagList.length) {
            setPlay(false);

            return;
        } else if (index < 0) index = 0;

        setCurrentIndex(index);
        const matchedVideo = videoList.filter((item) => item.id === tagList[index].game_id)[0];
        if (matchedVideo) {
            setVideoURL(matchedVideo.url);
            player.current.seekTo(toSecond(tagList[index].start_time));
        }
    };

    const deleteRowsBeforeUnload = (rows) => (e) => {
        e.preventDefault();
        window.alert(rows);

        GameService.deleteMultipleDataByIds(rows);
        e.returnValue = rows;

        return '';
    };

    useEffect(() => {
        (async () => {
            const pathname = window.location.pathname;

            if (pathname.match(/\/new_coach\/multiple\//) !== null) {
                let list = [];
                let splits = atob(params.ids).split('|');

                setCurrentIndex(0);
                setVideoList([]);
                window.addEventListener('beforeunload', deleteRowsBeforeUnload(splits[1]));
                await GameService.getGamesByIds(splits[0]).then((res) => {
                    res.map(async (game) => {
                        if (game.video_url.includes('youtube.com') || game.video_url.includes('youtu.be')) {
                            await GameService.getNewStreamURL(game.video_url).then((res) => {
                                list = [...list, { id: game.id, url: res.result.video_url }];
                            });
                        } else if (game.video_url.toLowerCase() !== 'no video') list = [...list, { id: game.id, url: game.video_url }];
                    });
                    setVideoList(list);
                });
                await GameService.getAllMultipleDataByIds(splits[1]).then((res) => {
                    setTagList(res);

                    if (list.length > 0 && res.length > 0) setVideoURL(list.filter((item) => item.id === res[0].game_id)[0].url);
                });

                return () => {
                    window.removeEventListener('beforeunload', deleteRowsBeforeUnload);
                };
            }
        })();
    }, [params]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh' }}>
            <div style={{ width: '80%', margin: 'auto' }}>
                <div style={{ width: '100%', margin: 'auto', position: 'relative' }}>
                    <FullScreen handle={handle}>
                        <div style={{ width: '100%', margin: 'auto', minWidth: '700px' }}>
                            <div className="player-wrapper">
                                <ReactPlayer
                                    className="react-player"
                                    url={videoURL}
                                    ref={player}
                                    onPlay={() => setPlay(true)}
                                    onPause={() => setPlay(false)}
                                    onProgress={(p) => onProgress(p.playedSeconds)}
                                    playing={play}
                                    controls={false}
                                    playbackRate={playRate}
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                position: 'absolute',
                                padding: '0 16px',
                                top: '12px',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', flex: 6 }}>
                                <ClipEditButton
                                    tag={tagList[currentIndex]}
                                    t={t}
                                    onOpen={() => setPlay(false)}
                                    onClose={() => setPlay(true)}
                                    sx={{ color: 'red' }}
                                />
                                {tagList.length > 0 && currentIndex < tagList.length && showLogo && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center', flex: 4 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#17375E', width: '110px'  , borderRadius:'5px'}}>
                                            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1.4rem', fontWeight: 500, color: '#ffffff' }}>
                                                {`${tagList[currentIndex].period} - ${tagList[currentIndex].time}'`}
                                            </Typography>
                                        </div>
                                        <img src={tagList[currentIndex].home_team_image ? tagList[currentIndex].home_team_image : TEAM_ICON_DEFAULT} style={{ width: '45px', height: '45px' }} />
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff', width: '90px'  , borderRadius:'5px'}}>
                                            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1.4rem', fontWeight: 500, color: '#17375E' }}>
                                                {`${tagList[currentIndex].home_team_goals} : ${tagList[currentIndex].away_team_goals}`}
                                            </Typography>
                                        </div>
                                        <img src={tagList[currentIndex].away_team_image ? tagList[currentIndex].away_team_image : TEAM_ICON_DEFAULT} style={{ width: '45px', height: '45px' }} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', left: 0, bottom: '16px', justifyContent: 'space-between', width: '100%', padding: '0 16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <IconButton onClick={() => PlayVideo(-1)} style={{ color: '#ffffff', backgroundColor: '#80808069' }}>
                                    <SkipPreviousSharpIcon color='#ffffff' />
                                </IconButton>
                                <IconButton style={{ color: '#ffffff', backgroundColor: '#80808069' }} onClick={() => fastVideo(-3)}>
                                    <FastRewindIcon color='#ffffff' />
                                </IconButton>
                                <Button variant="outlined" sx={{ width: '60px', color: '#ffffff' }} onClick={() => setPlayRate(0.5)}>
                                    Slow
                                </Button>
                                <IconButton
                                    onClick={() => {
                                        if (playRate === 1) setPlay((p) => !p);
                                        else setPlayRate(1);
                                    }}
                                    style={{ color: '#ffffff', backgroundColor: '#80808069' }}
                                >
                                    {play && playRate === 1 ? <PauseIcon /> : <PlayIcon />}
                                </IconButton>
                                <Button variant="outlined" sx={{ width: '60px', color: '#ffffff' }} onClick={() => setPlayRate((s) => s + 0.5)}>
                                    Fast
                                </Button>
                                <IconButton style={{ color: '#ffffff', backgroundColor: '#80808069' }} onClick={() => fastVideo(3)}>
                                    <FastForwardIcon color='#ffffff' />
                                </IconButton>
                                <IconButton onClick={() => PlayVideo(1)} style={{ color: '#ffffff', backgroundColor: '#80808069' }}>
                                    <SkipNextSharpIcon />
                                </IconButton>
                            </div>
                        </div>
                    </FullScreen>
                </div>

            </div>
        </div>
    );
};

export default MultipleStatsVideoPlayer;
